import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DOMPurify from "dompurify";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useSearchParams } from "react-router-dom";
import AppFooter from "@components/AppFooter/AppFooter";
import AppNavbar from "@components/AppNavbar/AppNavbar";
import GeneralConst from "@consts/GeneralConst";
import BlogService from "@services/BlogService";
import AlertStrings from "@strings/AlertStrings.json";
import GeneralStrings from "@strings/GeneralStrings.json";
import "./ViewBlogPost.scss";

const ViewBlogPost = () => {
  const [post, setPost] = useState<BlogPost | null>(null);
  const [hasError, setHasError] = useState(false);
  const [searchParams] = useSearchParams();
  const blogStrings = GeneralStrings.blog;

  useEffect(() => {
    const id = searchParams.get("id");
    const numericId = id ? parseInt(id, 10) : null;
    if (numericId !== null && !isNaN(numericId)) {
      BlogService.getBlogPostById(numericId)
        .then((response) => {
          setPost(response?.data);
        })
        .catch(() => {
          setHasError(true);
        });
    } else {
      setHasError(true);
    }
  }, [searchParams]);

  if (hasError) {
    return (
      <>
        <AppNavbar />
        <div className="view-blog-post-error">
          <p>{AlertStrings.generalError}</p>
        </div>
        <AppFooter />
      </>
    );
  }

  return post ? (
    <>
      <Helmet>
        <title>{`${post.title} | ${GeneralConst.SITE_NAME}`}</title>
      </Helmet>
      <AppNavbar />
      <div className="view-blog-post">
        <header
          className="masthead"
          style={{
            backgroundImage: `url(${post.imgLoc})`,
          }}
        >
          <div className="container position-relative">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-8 col-xl-7">
                <div className="post-heading">
                  <h1>{post.title}</h1>
                  <h2 className="subheading">{post.subtitle}</h2>
                  <span className="meta">
                    <AccessTimeIcon />
                    <span className="date">
                      {blogStrings.postedOn.replace("{date}", post.date)}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </header>
        <article className="article-container">
          <div className="container px-4 px-lg-5">
            <div className="row gx-4 gx-lg-5 justify-content-center">
              <div
                className="col-md-10 col-lg-8 col-xl-7"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(post.content),
                }}
              />
            </div>
          </div>
        </article>
      </div>
      <AppFooter />
    </>
  ) : null;
};

export default ViewBlogPost;
